// extracted by mini-css-extract-plugin
module.exports = {"depositListHistoryList":"DepositListHistoryList-Jtails_depositListHistoryList_2Z93B","prepaidList":"DepositListHistoryList-Jtails_prepaidList_3o77-"};